module.exports = __webpack_public_path__ + "img/remmert-company-logo.1663449d.jpg";